import moment from 'moment';
import React, { useContext } from 'react';
import { OrderDetailsContext } from '../../../context/OrderDetailsContext';
import './OrderDetailSection.scss';

const OrderDetailSection = () => {
  const { orderDetail, slottedOrder } = useContext(OrderDetailsContext);

  return (
    <div className="slottedOrderSection">
      <ol className="slottedDeliveryInfoContainer">
        <li className="trackingInfo">
          {/* <div className="decorator">
            <img
              src="https://staging.nandus.com/my-assets/image/category/ff3e808e9ec0fb0f38800204016bf425.jpg"
              alt=""
            />
          </div> */}
          <p style={{ display: 'block', marginBottom: '10px' }}>
            {' '}
            Your order will be delivered in the requested slot.
          </p>
          <p style={{ display: 'block', marginBottom: '0' }}>
            {' '}
            you can start tracking from{' '}
            {slottedOrder === 'yes' && (
              <>
                <span style={{ fontWeight: 'bold', padding: '0 .3rem' }}>
                  {moment(orderDetail?.response?.timeSlotStart).format('LT')}
                </span>{' '}
                on
                <span style={{ fontWeight: 'bold', padding: '0 .3rem' }}>
                  {moment(orderDetail?.response?.timeSlotStart).format('LL')}
                </span>
              </>
            )}
            .
          </p>
        </li>

        <li className="checkingOutInfo">
          {/* <div className="decorator">
            <img
              src="https://staging.nandus.com/my-assets/image/category/52af625265af05f1ed7dc9cd5080e731.png"
              alt=""
            />
          </div> */}
          <p style={{ display: 'block', marginTop: '15px' }}>
            By then , why dont you{' '}
            <a
              href="https://www.nandus.com/"
              target="_blank"
              rel="noreferrer"
              className="linkToWebsite"
            >
              check out
            </a>{' '}
            if you need anything else for your meal.
          </p>
        </li>
      </ol>
    </div>
  );
};

export default OrderDetailSection;
